

class Notification {}

export default Notification;